import { Button, Grid } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from '@material-ui/core/TextField';
import SearchIcon from "@material-ui/icons/Search";

import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import {updateBot } from "../../apis/bots";
import DoneIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import InputAdornment from "@material-ui/core/InputAdornment";
import AutomationROI from "../AutomationROI";
import useStyles from "../muistyles";
import { UpdateBotMetadataForm } from "./UpdateBotMetadataForm";
import {Table} from "../GenericReusableComponents/Table"
import { LightTooltip } from "../LightTooltip";


export function BotsLifeCycle() {
  const [bots, setBots] = useState([]);
  const [filteredBots, setFilteredBots] = useState([]);
  const [botsChanged, setBotsChanged] = useState(true);
  const [botInEdit,setBotInEdit] = useState({});
  const [showUpdateBotMetaData,setShowUpdateBotMetaData] = useState(false);

  const [q, setQ] = useState("");
  const tableColumnsHeader = [
    "Number",
    "Bot Name",
    "Documentation",
    "Subtasks",
    "Last Updated",
  ];


  function getTableHeader(){
    return(
      tableColumnsHeader.map(i =>(
        <th>{i}</th>
      ))
    )
  }

  useEffect(() => {
    getBotsDetailedList()
  }, [botsChanged]);

  const classes = useStyles();

  function filterTable(filterString) {
    console.log("Search " + filterString);
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredBots(bots);
      setQ("");
      console.log(bots);
    } else {
      setQ(filterString);
      setFilteredBots(filterBots(bots));
    }
   
  }

  function getBotsDetailedList(){

    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json'}
      }
  
      fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/bots/detailed-list/'  , requestOptions)
      .then (async response => {
        const data = await response.json();
        if (!response.ok) 
        {
            const error = (data && data.message) || response.status;
            console.error('API error:', { response, data, error });
            return Promise.reject(error);
            
        }
        // console.log(data)

          setBots(data);
          setFilteredBots(data);
          setBotsChanged(false);
  
      })

      .catch(error => {alert(error)});

  }

  function filterBots(lbots){
    if(q === ""){
      var fbots = [];
      lbots.forEach((x) => fbots.push(x));
      return fbots;
    }
    return lbots.filter((bot) => {
      if (bot.botName.startsWith(q)) return true;

      if (bot.documentation.startsWith(q)) return true;

      if (bot.lastUpdated.startsWith(q)) return true;

      if (bot.subtasks.startsWith(q)) return true;

      return false;
    })
  }

  function updateBotsState(bot){
    let lbots = [...filteredBots];
    let i = lbots.findIndex((b) => b.botID === bot.botID);
    lbots[i]={...bot};
    // setBots(lbots);
    setFilteredBots(lbots);
  }

  function handleClickOnEdit(bot){
    // bot.makeRowEditable = true;

    console.log(`handleClickOnEdit ${JSON.stringify(bot)}`)
    setBotInEdit({...bot});
    setShowUpdateBotMetaData(true);
    // updateBotsState(bot);
  }

  function handleOnClickClose(bot){
    bot.makeRowEditable = false;
    updateBotsState(bot);
  }

  function handleOnClickDone(bot){
    let lbot = {...botInEdit};
    lbot.makeRowEditable = false;
    updateBot(lbot);
    setBotsChanged(true);
    
  }

  // function onChangeBotName(e,bot){
  //   botInEdit.botName = e.target.value;
  // }

  function displayBotName(bot){
    if(bot.makeRowEditable){
      return (
        <TextField required label="Required" id="botName" defaultValue={bot.botName} onChange={(e)=>{botInEdit.botName = e.target.value}}/>   
      )
    }
    return bot.botName;
  }

  // function displayVersion(bot){
  //   return bot.botVersion;
  // }

  function displaySubtasks(bot){
    return bot.subtasks;
  }


  // function displayStatus(bot){
    
  //   if(bot.botStatus === "DEPLOYED"){
  //     return bot.botStatus;
  //   }
    
  //   if(bot.makeRowEditable){
  //     return(
  //         <Select defaultValue={bot.botStatus} onChange={(e)=>botInEdit.botStatus = e.target.value}>
  //           <MenuItem value="NOT ASSIGNED" >NOT ASSIGNED</MenuItem>
  //           <MenuItem value="ASSIGNED">ASSIGNED</MenuItem>
  //           <MenuItem value="DESIGN">DESIGN</MenuItem>
  //           <MenuItem value="DEPLOYABLE">DEPLOYABLE</MenuItem>
            
  //         </Select>
  //     );
  //   }
  //   return bot.botStatus;
  // }

  function displayDocumentation(bot){
    if(bot.makeRowEditable){
      return (
        <TextField required label="Required" id="botDesciprtion"  defaultValue={bot.botDescription} onChange={(e)=>{botInEdit.botDescription = e.target.value}}/>   
      )
    }
    var documentation = bot.documentation
    if (documentation != undefined && documentation.length > 400) {
      documentation = documentation.substring(0, 400) + "...";
    }
    return documentation;
  }

  function displayLastUpdated(bot){
    if(bot.makeRowEditable){
      return (
        <TextField required label="Required" id="botDesciprtion"  defaultValue={bot.botDescription} onChange={(e)=>{botInEdit.botDescription = e.target.value}}/>   
      )
    }
    return bot.lastUpdated;
  }


  function displayActions(bot) {
    if(bot.makeRowEditable){
      return (
        <>
        <LightTooltip title="Edit Documentation">
        <Button onClick={()=>handleOnClickDone(bot)}>
          <IconButton>
            <DoneIcon/>
          </IconButton>
        </Button>
        </LightTooltip>

        <Button onClick={()=>handleOnClickClose(bot)}>
          <IconButton>
            <CloseIcon/>
          </IconButton>
        </Button>

        </>
      )
    }
    
      return(
       
        <Button onClick={()=>handleClickOnEdit(bot)}>
          <IconButton>
            <EditIcon></EditIcon>
          </IconButton>
        </Button>
      )     

  }

  function getTableBody(){
    return(
      filteredBots.map((bot, index) => (
        <tr style={{ lineHeight: "41px" }}>
          
          <td>{index + 1}</td>
          <td>{displayBotName(bot)}</td>
          <td>{displayDocumentation(bot)}</td>
          <td>{displaySubtasks(bot)}</td>
          <td>{displayLastUpdated(bot)}</td>
          {/* <td>{displayActions(bot)}</td> */}
        </tr>
      ))
    )
  }

  return (
    <div>
    
        <Table search={filterTable} 
               columns={getTableHeader()}
               rows={getTableBody()}
               />


      <UpdateBotMetadataForm 
        showUpdateBotMetaData={showUpdateBotMetaData} 
        setShowUpdateBotMetaData={setShowUpdateBotMetaData} 
        bot={botInEdit} 
        setBotListChanged={setBotsChanged} />
    </div>
  );
}
